<template>
    <div class="tax-table-wrap" :class="[`tax-status-${taxData.status}`]" v-if="isInit">
        <dl class="tax-table-header">
            <dt>企业所得税汇总纳税总分支机构所得税分配表</dt>

            <div style="text-align: center;margin-bottom: 10px;">
                税款所属期：{{ staticConfig.taxStartTime }} ~ {{ staticConfig.taxEndTime }}
            </div>
            <dd>

                <div>
                    总机构名称（盖章）：<br/>
                    总机构纳税人识别号（统一社会信用代码）：{{ staticConfig.fillFormDate }}
                </div>

                <div>金额单位：元（列至角分）</div>
            </dd>
        </dl>

        <div class="tax-table-body">
            <table>
                <tbody>
                <tr>
                    <td colspan="2">本年实际应纳所得税额</td>
                    <td colspan="2">总机构直接管理建筑项目<br/>部预分所得税额</td>
                    <td colspan="2">总机构实际应分摊所得<br/>税额</td>
                    <td colspan="4">财政集中实际应分配所得税额</td>
                    <td colspan="2">分支机构实际应分摊所得税额</td>
                </tr>

                <tr>
                    <td colspan="2" style="height: 35px;"></td>
                    <td colspan="2"></td>
                    <td colspan="2"></td>
                    <td colspan="4"></td>
                    <td colspan="2"></td>
                </tr>

                <tr>
                    <td rowspan="2" style="min-width: 80px;">总分机构情况</td>
                    <td rowspan="2">纳税人识别号（统一社会信用代码）</td>
                    <td rowspan="2">机构名称</td>
                    <td colspan="3">三项因素</td>
                    <td rowspan="2">分摊比例</td>
                    <td rowspan="2">实际应分摊所得税额</td>
                    <td rowspan="2">累计已分摊所得税额</td>
                    <td rowspan="2">分摊应补（退）所得税额</td>
                    <td rowspan="2">民族自治地区企业所得税地方分享部分优惠金额（&#9634;免征 &#9634;减征：减征幅度__%）</td>
                    <td rowspan="2">实际分摊应补（退）所得税额</td>
                </tr>

                <tr>
                    <td>营业收入</td>
                    <td>职工薪酬</td>
                    <td>资产总额</td>
                </tr>

                <tr>
                    <td>总机构分摊</td>
                    <td>
                        <el-input-number v-model.trim="data.v2x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v2x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>

                <tr>
                    <td>总机构财政集中分配</td>
                    <td>
                        <el-input-number v-model.trim="data.v3x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v3x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>

                <tr>
                    <td rowspan="8">
                        分支机构分摊
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v4x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v5x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v5x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v6x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v6x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v7x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v7x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v8x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v8x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v9x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v9x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-input-number v-model.trim="data.v10x1.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x2.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v10x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        分支机构合计
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x3.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x4.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x5.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x6.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x7.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x8.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x9.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x10.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                    <td>
                        <el-input-number v-model.trim="data.v11x11.value" :controls="false" :precision="2" :step="0.01"
                                         :value-on-clear="0.0"/>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<style scoped lang="scss">
.tax-table-wrap {
    width: 1200px !important;
}
</style>

<script setup>
import {cloneDeep} from "lodash";
import Big from "big.js";
import {reportTaxDateConfig} from "../../../reportTaxStaticConfig.js";
import taxQue from "../../../cmp/taxQue.vue";

const currentQa = inject("provideCurrentQa");
const staticConfig = computed(() => reportTaxDateConfig(currentQa.value).staticConfig);

const isInit = ref(false);
const mode = ref(null);

// 初始数据
const taxDataAll = ref({});
const taxData = ref({});
const data = ref({});
// 初始化
const init = (options = {}) => {
    mode.value = options.mode;
    taxDataAll.value = cloneDeep(options.taxDataAll);
    // 当前数据
    taxData.value = cloneDeep(options.taxData);
    // 当前数据的表单数据
    data.value = cloneDeep(options.taxData.data);
    watchStart();
    isInit.value = true;
};
// 返回数据
const getData = () => {
    if (!isInit.value) {
        return;
    }

    return toRaw(data.value);
};

function watchStart() {
    watch(data, (newVal, oldVal) => {
    }, {
        deep: true,
        immediate: true,
    });
}

// 小数点
function parseFloatNum(s, num = 2) {
    try {
        return new Big(s).toFixed(num);
    } catch (e) {
    }
}

defineExpose({
    init,
    getData,
});
</script>

<style scoped lang="scss">
.tax-table-wrap {
    width: 1200px !important;
}
</style>
